import React, {useState, useEffect} from 'react';
import "./MIndustries.css";

import MStartNow from '../MStartNow/MStartNow';
import MapItButton from '../../Common/MapItButton/MapItButton';

import qrcode from '../../../Assets/QR_Code.png'
import back_btn from '../../../Assets/BackArrow-48x48.png'
import listing from '../../../Assets/Listing-example.png'
import cloud from '../../../Assets/cloud_storage.png'
import smartPlan from '../../../Assets/Digital-Interactions-Page-Media.png'
import MapItFp from '../../MapItFp/MapItFp';
import realtor from '../../../Assets/indstry-realtor-promo.jpg';

import ImageGallery from "react-image-gallery";
import { useNavigate } from 'react-router-dom';
import {Helmet} from "react-helmet";
import PageTitle from '../../Common/PageTitle/PageTitle'; // Adjust the path as per your file structure

// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";

const MIndustries = () => {

  const industryList = ["RE", "C", "ID","T","BM"];

  const [curIndst, setCurIndst] = useState(0);
  const [clickIdx, setClickIdx] = useState(0);

  const [images, setImages] = useState([]);

  let navigate = useNavigate();

  // useEffect(() => {
  //   setTimeout(incrementCurIndex, 6000);
  // }, [curIndst]);

  const incrementCurIndex = () => {
    setClickIdx((clickIdx+1)%industryList.length);
    setCurIndst((clickIdx+1)%industryList.length);
  }

  const GetIndustryInfo = () => {

      switch(industryList[clickIdx]) {
        case "RE":
          return (
          <div className="industry-desc">
            <div className="industries-div2">
              <p className='industries-4'>
              Advertise your listings with QR codes and weblinks. Schdule buyer viewings. 
              Generate buyer reports on the number of houses seen, average sale prices, etc. 
              Close deals faster with notificatons and reminders.
              </p>
            </div> 
            <div className="industry-fpImgDiv">
              {/* <iframe 
                className='industry-FloorplanImg'
                src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png"
                frameBorder="0"
                allow="accelerometer"
                allowFullScreen
              /> */}
              <img src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png" width="157.81vh" height="60vh"/>
            </div>        
          </div>
          );
        case "C":
          return (
          <div className="industry-desc">
            <div className="industries-div2">
              <p className='industries-4'>
              Efficiently oversee your team, coordinate projects, maintain daily progress reports, and ensure thorough documentation to minimize legal risks.
              </p>
            </div> 
            <div className="industry-fpImgDiv">
              {/* <iframe 
                className='industry-FloorplanImg'
                src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png"
                frameBorder="0"
                allow="accelerometer"
                allowFullScreen
              /> */}
              <img src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png" width="157.81vh" height="60vh"/>
            </div>       
          </div>
          );
        case "ID":
          return (
          <div className="industry-desc">
            <div className="industries-div2">
              <p className='industries-4'>
              Conduct site inspections with ease, generate on-site report and perform validations directly on your plans. Streamline communication and access reports on the go.              </p>
            </div> 
            <div className="industry-fpImgDiv">
              {/* <iframe 
                className='industry-FloorplanImg'
                src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png"
                frameBorder="0"
                allow="accelerometer"
                allowFullScreen
              /> */}
              <img src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png" width="157.81vh" height="60vh"/>
            </div>         
          </div>
          );
        case "T":
          return (
           <div className="industry-desc">
            <div className="industries-div2">
              <p className='industries-4'>
              Facilitate on-site communication between trades, report and address issues effectively, organize your tasks, and document your work to mitigate liabilities.              
              </p>
            </div> 
            <div className="industry-fpImgDiv">
              {/* <iframe 
                className='industry-FloorplanImg'
                src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png"
                frameBorder="0"
                allow="accelerometer"
                allowFullScreen
              /> */}
              <img src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png" width="157.81vh" height="60vh"/>
            </div>      
          </div>
          );
        case "BM":
          return (
          <div className="industry-desc">
            <div className="industries-div2">
              <p className='industries-4'>
              Efficiently communicate building issues with precise location details, stay updated on each building's progress, and effectively relay concerns to contractors.
              </p>
            </div> 
            <div className="industry-fpImgDiv">
              {/* <iframe 
                className='industry-FloorplanImg'
                src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png"
                frameBorder="0"
                allow="accelerometer"
                allowFullScreen
              /> */}
              <img src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapItLogo-384x146.png" width="157.81vh" height="60vh"/>
            </div>        
          </div>
          );
      }
  }

  const onSubmit = () => {
    navigate("/login");
  }

  const getWidth = (type) => {
    const win_width = window.innerWidth;
    let width = 0;
    switch (type) {
        case "qr":
            width = win_width*0.0182;
            break;
        case "smart":
            width = win_width*0.036;
            break;
        case "listing":
            width=win_width*0.26;
            break;
        case "cloud":
            width=win_width*0.8;
            break;
        default:
            width=win_width*0.26;
    }
    return width;
}

const getHeight = (type) => {
    const win_height = window.innerHeight;
    const win_width = window.innerWidth;
    let height = 0;
    switch (type) {
        case "qr":
            height = win_width*0.0182;
            break;
        case "smart":
            height = win_height*0.042;
            break;
        case "listing":
            height=win_width*0.26;
            break;
        case "cloud":
            height=win_width*0.8;
            break;
        default:
            height=win_width*0.26;
    }
    return height;
}

  return(
    <div className="industries-outter">
      <PageTitle title="MapIt Use Cases"/>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://mapit.cc/industries" />
      </Helmet>
      <div className="industries-inner">
        <div className="mindustries-hero">
          <div className="industries-header-div">
          <p className="mindustries-header">
            Interactive Floor Plans for Every Industry
          </p>
          </div>
          <div className="industries-promo-div">
          <p className='mindustries-promo-text'>
            From real estate and photography to construction and insurance, MapIt helps professionals turn floor plans and photos into powerful, interactive maps in minutes
          </p>
          </div>
          <div className="industries-btn">
            <MapItButton onSubmit={onSubmit} text="Get started for free" className="mGetStartedButtonIndstry"></MapItButton>
          </div>
        </div>
        {curIndst == -1
        ?
        <div className="indstry-grid-outter">
        {/* <div className="indstry-grid-inner">
            <div className="indstry-grid-item" onClick={() => setCurIndst(0)}>
              <div className="indstry-img">
                <img 
                  src={qrcode}
                  width="64px"
                  height="64px"
                  alt="qr code virtual tour"
                />
              </div>
              <div className="indstry-desc">
                <p className="indstry-tile-title">Realtors & Brokers</p>
                <p className="indstry-tile-p">
                Interactive floor plans help buyers understand a property instantly — no guessing, no confusion, and no jumping through static photo galleries
                </p>
              </div>
            </div>
            <div className="indstry-grid-item2" onClick={() => setCurIndst(1)}>
              <div className="indstry-img">
                <img 
                  src={qrcode}
                  width="64px"
                  height="64px"
                  alt="qr code virtual tour"
                />
              </div>
              <div className="indstry-desc">
                  <p className="indstry-tile-title">Photographers</p>
                  <p className="indstry-tile-p">
                  Turn your regular photo shoot into a premium, interactive product.
                  </p>
              </div>
            </div>
        </div>
        <div className="indstry-grid-inner" onClick={() => setCurIndst(3)}>
            <div className="indstry-grid-item">
            <div className="indstry-img">
                <img 
                  src={qrcode}
                  width="64px"
                  height="64px"
                  alt="qr code virtual tour"
                />
                </div>
                <div className="indstry-desc">
                    <p className="indstry-tile-title">Interior Designers & Home Stagers</p>
                    <p className="indstry-tile-p">
                    Visualize room concepts, layouts, and before/after transformations.
                    </p>
                </div>
            </div>
            <div className="indstry-grid-item2" onClick={() => setCurIndst(4)}>
            <div className="indstry-img">
                <img 
                  src={qrcode}
                  width="64px"
                  height="64px"
                  alt="qr code virtual tour"
                />
                </div>
                <div className="indstry-desc">
                    <p className="indstry-tile-title">Facility & Property Management</p>
                    <p className="indstry-tile-p">Track maintenance issues, unit conditions, and building documentation.</p>
                </div>
            </div>
        </div>
        <div className="indstry-grid-inner">
            <div className="indstry-grid-item" onClick={() => setCurIndst(5)}>
            <div className="indstry-img">
                <img 
                  src={qrcode}
                  width="64px"
                  height="64px"
                  alt="qr code virtual tour"
                />
                </div>
                <div className="indstry-desc">
                    <p className="indstry-tile-title">Insurance & Claims Adjusters</p>
                    <p className="indstry-tile-p">
                    Document property conditions fast — link every damage photo directly to its location.
                    </p>
                </div>
            </div>
            <div className="indstry-grid-item2" onClick={() => setCurIndst(6)}>
              <div className="indstry-img">
                <img 
                  className="indstry-img-img"
                  src={qrcode}
                  width="64px"
                  height="64px"
                  alt="qr code virtual tour"
                />
              </div>
              <div className="indstry-desc">
                  <p className="indstry-tile-title">Construction & Renovation</p>
                  <p className="indstry-tile-p">Track progress, document every area of the job site, and keep clients updated visually.</p>
              </div>
            </div>
        </div> */}
        </div>
        :
        <div>
          {/* <div className="backBtn">
            <img
              className='backBtnImg'
              src={back_btn}
              width="32px"
              height="32px"
              alt="qr code virtual tour"
              onClick={()=>setCurIndst(-1)}
            />          
          </div> */}
          <div className="mindstry-details">
            <div className="mindstry-detail-img">
              <img
                className='indstry-detail-img-img'
                src={realtor} 
                width={getWidth("cloud")} 
                height={getHeight("cloud")}
                alt="storage for real estate plans, photos and videos"
              />
            </div>
            <div className="mindstry-detail-text">
              <div className="mindstry-pain">
                <p className="prob-title">
                  Common Pain Points
                </p>
                <ul className="blt-ptns">
                  <li>Listings look flat and hard to follow</li>
                  <li>Photos confuse buyers because they can’t visualize flow</li>
                  <li>3D tours are expensive and time-consuming</li>
                  <li>Traditional floor plans don’t include context</li>
                </ul>
              </div>
              <div className="indstry-soln">
                <p className="soln-title">
                  How MapIt Helps
                </p>
                <ul className="blt-ptns">
                  <li>Combine your floor plan + listing photos to show the home's layout clearly</li>
                  <li>Create interactive maps in minutes without special hardware</li>
                  <li>Share with buyers via a simple link</li>
                  <li>Works perfectly for MLS, websites, and social media</li>
                </ul>  
              </div>              
            </div>
          </div>
          <div className="industry-demo-outter">
            <div className="mindstry-demo">
              <div className="mgal-div">
                <div className="gallery">
                  <ImageGallery items={images} showFullscreenButton={false} showPlayButton={false}/>
                </div>
                <div className="caption">
                  <p className="mcaption-p">Photos confuse buyers because they can’t visualize flow</p>
                </div>
              </div>
              <div className="mmap-div">
                <div className="Mapit-fp">
                  <MapItFp setImages={setImages}></MapItFp>
                </div>
                <div className="caption">
                <p className="mcaption-p">Buyers understand the layout instantly</p>
                </div>
              </div>
            </div>
            {/* <div className="caption">
            </div> */}
            {/* <div className="indstry-key-points">
              <div className="indstry-key-points-inner">
                <p className="prob-title">
                  Key Benefits for Agents
                </p>
                <ul className="blt-ptns">
                  <li>More engaging listings</li>
                  <li>Lower buyer questions</li>
                  <li>Stronger marketing for every property</li>
                  <li>Easy to embed and share</li>
                </ul>
              </div>
            </div> */}
          </div>
          {/* <div className="indstry-spacer">&nbsp;</div> */}
        </div>
        }
      </div>
      <MStartNow divStyle="StartNow-outter-indst" buttonStyle="mgetStartedButton2"></MStartNow>
    </div>
  );
}

export default MIndustries;